<mat-accordion>
    <mat-expansion-panel [expanded]="true">
        <mat-expansion-panel-header class="v-bg-primary">
            <mat-panel-title>
                <span class="text-light fs-5 f-bold">Configuration</span>
            </mat-panel-title>
        </mat-expansion-panel-header>
        <form [formGroup]="newformmainconfig">
            <div class="container pt-3">
                <div class="row">
                    <div class="col-sm">
                        <mat-form-field>
                            <input matInput type="number" formControlName="radius" placeholder="Radius (KM)">
                        </mat-form-field>
                    </div>
                </div>
            </div>
            <button (click)="saveMainConfig()" [disabled]="!newformmainconfig.valid" class="btn btn-success">Save Configuration</button>
        </form>
    </mat-expansion-panel>
</mat-accordion>